export function someExportedFunction() {
    // ...
  }
  
  declare global {
     var userID: number;
  }
  ///comment
  const userID = 0;